import { VisuallyHidden } from '@repletoryreach/sdk-ui';
import { SegmentedControl } from '@repletoryreach/sdk-ui/inputs';
import type { ViewMode } from '@repletoryreach/sdk-ui/data-display';
import { useT } from '../../../i18n/I18nProvider';

const ListIcon = (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden>
    <circle cx="3" cy="4" r="0.9" fill="currentColor" stroke="none" />
    <line x1="6" y1="4" x2="14" y2="4" />
    <circle cx="3" cy="8" r="0.9" fill="currentColor" stroke="none" />
    <line x1="6" y1="8" x2="14" y2="8" />
    <circle cx="3" cy="12" r="0.9" fill="currentColor" stroke="none" />
    <line x1="6" y1="12" x2="14" y2="12" />
  </svg>
);

const TableIcon = (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" aria-hidden>
    <rect x="2" y="2.5" width="12" height="11" rx="1.3" />
    <line x1="2" y1="6.2" x2="14" y2="6.2" />
    <line x1="2" y1="9.9" x2="14" y2="9.9" />
    <line x1="6.5" y1="6.2" x2="6.5" y2="13.5" />
  </svg>
);

/**
 * Table or list, in the page header where the designs put it.
 *
 * `TableShell` carries a switcher of its own, but the reference puts this
 * control beside the page's primary action rather than in the table toolbar,
 * which keeps the toolbar for the controls that change what the table counts.
 * The label is visually hidden rather than dropped, so the control still names
 * itself to a screen reader.
 */
export function ViewToggle({ value, onChange }: { value: ViewMode; onChange: (next: ViewMode) => void }) {
  const t = useT();
  return (
    <SegmentedControl
      size="xs"
      value={value}
      onChange={(v) => onChange(v as ViewMode)}
      data={[
        { value: 'list', label: <span title={t('view.list')}>{ListIcon}<VisuallyHidden>{t('view.list')}</VisuallyHidden></span> },
        { value: 'table', label: <span title={t('view.table')}>{TableIcon}<VisuallyHidden>{t('view.table')}</VisuallyHidden></span> }
      ]}
    />
  );
}
